import { Button, Icon, ModalFormWrapper, StateLabel } from '@goodlok/react-sdk'
import { useLocalLoading } from '@goodlok/ui'
import clsx from 'clsx'

import { FunctionComponent, useState } from 'react'
import type { AssignShiftData } from '../pages/api/assign-shift'
import { AdminPageData } from '../utilities/useAdminPageData'
import { getStaffName } from './AdminShiftTileSegment'
import styles from './AdminShiftTileSegmentPart.module.sass'
import { ShiftSettings } from './ShiftSettings'
import { UnassignModal } from './UnassignModal'

type AdminShiftTileSegmentPartProps = {
	assigned?: boolean
	confirmed?: boolean
	item: NonNullable<
		NonNullable<AdminPageData['getVenue']>['timetableDays'][number]['shiftGroups'][number]['queue']
	>['items'][number]
	position?: NonNullable<AdminPageData['getVenue']>['timetableDays'][number]['shiftGroups'][number]
	updateData: () => Promise<void>
	setChange: (changed: boolean) => void
	addEmployeeActive: boolean
	editShiftSlots: boolean
	swappedProfile?: NonNullable<
		AdminPageData['getVenue']
	>['timetableDays'][number]['shiftGroups'][number]['shifts'][number]['swapInfo']
	dayId: string
	unassignReasons: NonNullable<AdminPageData['getVenue']>['enabledUnassignReasons']
}

export const AdminShiftTileSegmentPart: FunctionComponent<AdminShiftTileSegmentPartProps> = ({
	assigned,
	confirmed,
	item,
	position,
	updateData,
	setChange,
	addEmployeeActive,
	editShiftSlots,
	swappedProfile,
	dayId,
	unassignReasons,
}) => {
	//@TODO: add styles based on loading
	const [loading, setLoading] = useLocalLoading()
	const isSwapped = swappedProfile ? true : false
	const [isUnassignModalActive, setIsUnassignModalActive] = useState(false)
	const [isShiftOptionsModalOpen, setIsShiftOptionsModalOpen] = useState(false)

	return (
		<>
			<div
				className={clsx(
					styles.assignEmployee,
					assigned && styles.assignedEmployee,
					confirmed && assigned && styles.confirmedEmployee,
					(addEmployeeActive || editShiftSlots) && styles.disable,
					loading && styles.loading
				)}
				title={confirmed ? 'přijde, potvrzeno' : assigned ? 'přijde, nepotvrzeno' : 'může přijít'}>
				<button
					type="button"
					className={styles.assignButton}
					onClick={async () => {
						if (isSwapped) {
							return
						}
						setChange(true)
						setLoading(true)
						const response = await fetch(
							assigned || confirmed ? '/api/unassign-shift' : '/api/assign-shift',
							{
								method: 'POST',
								body: JSON.stringify({
									employeeId: item.shiftsProfile?.id,
									shiftGroupId: position?.id,
									startTime: item.start,
									endTime: item.end,
									dayId: dayId,
									queueItemId: item.id,
								}),
							}
						)
						const data: AssignShiftData = await response.json()
						if (data.covering) {
							window.alert('překrývající se směny!')
						}
						await updateData()
						setLoading(false)
					}}
				/>
				{isSwapped ? (
					<div className={styles.swappedEmployeeName}>
						{getStaffName(swappedProfile?.swappedShiftsProfile?.staff)}

						<StateLabel variant="warning">
							<span className={styles.employeeLabel}>{`Náhrada`}</span>
						</StateLabel>
					</div>
				) : (
					<>
						<div className={styles.employeeName}>{getStaffName(item.shiftsProfile?.staff)}</div>
					</>
				)}
				<div className={styles.startEndTime}>
					{item.start && item.start}
					{item.start && '-'}
					{item.end && item.end}
				</div>

				<div className={styles.optionButtons}>
					<button
						type="button"
						onClick={() => {
							setIsShiftOptionsModalOpen(true)
						}}
						className={styles.more}
						title="Možnosti">
						<Icon name="ellipsis" />
					</button>
				</div>
			</div>
			{position && item.shiftsProfile && (
				<UnassignModal
					isActive={isUnassignModalActive}
					setIsActive={setIsUnassignModalActive}
					shiftGroupId={position.id}
					employeeId={item.shiftsProfile.id}
					unassignReasons={unassignReasons}
				/>
			)}
			<ModalFormWrapper
				title="Nastavení směny"
				isOpen={isShiftOptionsModalOpen}
				onClose={() => {
					setIsShiftOptionsModalOpen(false)
				}}>
				<div className={styles.settingsContent}>
					<ShiftSettings
						updateData={updateData}
						item={item}
						onSubmit={() => {
							setIsShiftOptionsModalOpen(false)
						}}
					/>
					<Button
						type="button"
						variant="danger"
						onClick={() => {
							setIsShiftOptionsModalOpen(false)
							setIsUnassignModalActive(true)
						}}>
						Zaznamenat nepřítomnost
					</Button>
				</div>
			</ModalFormWrapper>
		</>
	)
}
